/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const orderKind = {
  LIMIT: 'LIMIT',
  MARKET: 'MARKET',
} as const

export type OrderKind = (typeof orderKind)[keyof typeof orderKind]
